import { Avatar, Descriptions, Divider, Drawer, Image } from "antd";
import parse from "html-react-parser";

import moment from "moment";

function ViewDetail(props: any) {
  let { openViewDetail, setOpenViewDetail, dataViewDetail } =
    props;
  const onClose = () => {
    setOpenViewDetail(false);
  };
  return (
    <>
      <Drawer
        title="Chức năng xem chi tiết"
        width={"50vw"}
        onClose={onClose}
        open={openViewDetail}>
        <Descriptions title="Thông tin danh mục" bordered column={2}>
          <Descriptions.Item label="ID" span={2}>
            {dataViewDetail?._id}
          </Descriptions.Item>
          <Descriptions.Item label="Tên" span={2}>
            {dataViewDetail?.name}
          </Descriptions.Item>
          <Descriptions.Item label="Image" span={2}>
            {<Image src={dataViewDetail?.image} preview={false} />}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày tạo">
            {moment(dataViewDetail?.createdAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày cập nhật">
            {moment(dataViewDetail?.updatedAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
        </Descriptions>
{/* 
        <Divider orientation="left">Ảnh bài viết</Divider>
        <Avatar shape="square" size={200} src={dataViewDetail?.image} /> */}
      </Drawer>
    </>
  );
}

export default ViewDetail;
